import { render, staticRenderFns } from "./invHistory.vue?vue&type=template&id=c77f7ee6&scoped=true&"
import script from "./invHistory.js?vue&type=script&lang=js&"
export * from "./invHistory.js?vue&type=script&lang=js&"
import style0 from "./invHistory.scss?vue&type=style&index=0&id=c77f7ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77f7ee6",
  null
  
)

export default component.exports